export default "__VITE_ASSET__BqTz8lKZ__"